module.exports = __webpack_public_path__ + "img/im_scrollfeature_02@2x.c6fc367c.jpg";